import React from "react";
import { v2, v3 } from "oc-threejs/short3";
import { coordinateSystem } from "../components/grundriss/CoordinateSystem";
import { GrundrissState } from "../arrangement/grundrissFunctions";
import { PageInitProps } from "./Inspiration";
import { ScreenUtils } from "oc-threejs/ScreenUtils";
import * as Commons from "oc-commons/Commons";
import { GrundrissPage } from "../components/grundriss/GrundrissPage";
import { JoyrideTour } from "../components/zauneditor/JoyrideTour";

export function resetGrundrissCamera() {
  APP.arrangement.update3d();
  Commons.sleepUntil(() => APP.renderer.domElement.getBoundingClientRect().width > 2).then(() => {
    const r = document.querySelector(".grundriss")?.getBoundingClientRect();
    const grundriss = APP.arrangement.grundriss;
    const su = new ScreenUtils();
    const y =
      su.getDistanceToCameraWhereWorldUnitsEqualsPixel(
        r,
        v2(grundriss.size.x || 10, grundriss.size.z || 10),
        false
      ) * 1.2;
    const grundrissMiddle = grundriss.getBox().grid(v3(0.5, 0, 0.5));
    grundrissMiddle.setY(y);
    const cs = coordinateSystem();
    cs.setCameraTo(grundrissMiddle);
    APP.updateUI();
  });
}

export class Grundriss extends React.Component {
  pageNeeds = {
    scene: true,
    grundriss: true,
    pageTypeForCssAnimation: 3,
  };

  state: Partial<GrundrissState> = {
    pageFadedIn: false,
    ready: false,
    modus: "zeichnen",
  };

  async init({ pageEnteredInSequence }: PageInitProps) {
    APP.undoHandler.enabled = true;
    APP.controls.maxDistance = 500;

    this.setNewState({ pageFadedIn: true });

    // if (APP.arrangement.grundriss.kanten.length == 0) {
    //   await new Promise((resolve, reject) => {
    //     _.delay(
    //       () =>
    //         showStandardFormPopover(() => {
    //           this.resetCamera();
    //           resolve("");
    //         }),
    //       600
    //     );
    //   });
    // }

    const styles = [...document.querySelectorAll(".raster,.stage2d")].map(
      (e) => (e as HTMLElement).style
    );
    styles.forEach((s) => (s.visibility = "hidden"));
    await Commons.sleep(100);
    this.resetCamera();
    await Commons.sleep(50);
    styles.forEach((s) => (s.visibility = "visible"));

    setTimeout(() => APP.arrangement.maybeHighlightBreadcrumb("Zauneditor"), 3500);
  }

  resetCamera() {
    this.setNewState({});
    resetGrundrissCamera();
  }

  setRenderSize() {
    this.resetCamera();
  }

  exit() {}

  async submit() {
    // await Commons.sleep(300);
    // const form = APP.arrangement.form;
    // const formA = this.state.formPlain;
    // const formB = form.clone();
    // const formUnsimilarity = formA.unsimilarityTo(formB);
    //
    // const animation = APP.createResetShapeAnimation();
    //
    // await APP.tween((t: number) => {
    //   AbstractForm.lerp(formA, formB, form, t);
    //   animation(t);
    // }, formUnsimilarity * 1000);
    //
    // const shape = form.shape;
    // form.update(shape);
    //
    // APP.logUserAction({ seitenLaengen: APP.arrangement.form.seitenLaengen });

    APP.showNextPage();
  }

  setNewState = (newState: Partial<GrundrissState>) => {
    const state = { ...this.state, ...newState };
    this.setState(state);
    Object.assign(this.state, state);
  };

  render() {
    return (
      <>
        {!APP.testmode && APP.tutorialParam !== false && <JoyrideTour page="grundriss" />}
        <GrundrissPage state={this.state} setNewState={this.setNewState} />
      </>
    );
  }
}

export default Grundriss;
